const BAR_TABLE = [
    { imperial: 3, metric: 10, weightPerFoot: 0.376, nominalDiameter: 0.375 },
    { imperial: 4, metric: 13, weightPerFoot: 0.668, nominalDiameter: 0.500 },
    { imperial: 5, metric: 16, weightPerFoot: 1.043, nominalDiameter: 0.625 },
    { imperial: 6, metric: 19, weightPerFoot: 1.502, nominalDiameter: 0.750 },
    { imperial: 7, metric: 22, weightPerFoot: 2.044, nominalDiameter: 0.875 },
    { imperial: 8, metric: 25, weightPerFoot: 2.670, nominalDiameter: 1.000 },
    { imperial: 9, metric: 29, weightPerFoot: 3.400, nominalDiameter: 1.128 },
    { imperial: 10, metric: 32, weightPerFoot: 4.303, nominalDiameter: 1.270 },
    { imperial: 11, metric: 36, weightPerFoot: 5.313, nominalDiameter: 1.410 },
    { imperial: 14, metric: 43, weightPerFoot: 7.650, nominalDiameter: 1.693 },
    { imperial: 18, metric: 57, weightPerFoot: 13.600, nominalDiameter: 2.257 },
];
export class BarSize {
    imperial;
    metric;
    weightPerFoot;
    nominalDiameter;
    constructor(data) {
        this.imperial = data.imperial;
        this.metric = data.metric;
        this.weightPerFoot = data.weightPerFoot;
        this.nominalDiameter = data.nominalDiameter;
    }
    static parse(input) {
        const trimmed = input.trim();
        if (trimmed.includes('/')) {
            const imperial = parseInt(trimmed.split('/')[1], 10);
            return BarSize.fromImperial(imperial);
        }
        if (trimmed.startsWith('#')) {
            return BarSize.fromImperial(parseInt(trimmed.substring(1), 10));
        }
        return BarSize.fromImperial(parseInt(trimmed, 10));
    }
    static fromImperial(size) {
        const data = BAR_TABLE.find(b => b.imperial === size);
        if (!data)
            throw new Error(`Unknown imperial bar size: #${size}`);
        return new BarSize(data);
    }
    static fromMetric(size) {
        const data = BAR_TABLE.find(b => b.metric === size);
        if (!data)
            throw new Error(`Unknown metric bar size: ${size}`);
        return new BarSize(data);
    }
    toString() {
        return `${this.metric}/${this.imperial}`;
    }
    toImperialString() {
        return `#${this.imperial}`;
    }
    equals(other) {
        return this.imperial === other.imperial;
    }
}
